import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { FaCheck } from 'react-icons/fa6';
import './socialHub.css';

const sampleEmployees = Array.from({ length: 8 }).map((_, i) => ({ value: `emp-${i+1}`, label: `Employee ${i+1}` }));

const ShareModalPreview = () => {
  const [open, setOpen] = useState(true);
  const [selected, setSelected] = useState([]);

  const handleShare = () => {
    alert('Shared with: ' + (selected || []).map(s=>s.label).join(', '));
    setOpen(false);
  };

  return (
    <div style={{ padding: 24, minHeight: '100vh', background: 'linear-gradient(180deg,#0f0c18,#16121f)' }}>
      <button style={{ marginBottom: 16 }} onClick={() => setOpen(true)}>Open Share Modal</button>
      <Modal show={open} onHide={() => setOpen(false)} centered backdrop="static" size="md" dialogClassName="share-modal">
        <Modal.Header closeButton>
          <div>
            <Modal.Title className="modal-title">Share Announcement</Modal.Title>
            <div className="modal-subtitle">Quickly share this announcement with selected employees</div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <label style={{ color: '#9ca3af', fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 8 }}>
            Select Employees to Share With
          </label>
          <Select
            isMulti
            options={sampleEmployees}
            value={selected}
            onChange={setSelected}
            placeholder="🔍 Search and select employees..."
            styles={{
              control: (base) => ({
                ...base,
                background: 'rgba(255,255,255,0.03)',
                border: '1px solid rgba(134,96,248,0.12)',
                color: '#fff',
                minHeight: 44,
                boxShadow: 'none',
                borderRadius: 8,
              }),
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <div style={{ display: 'flex', gap: 10, width: '100%', justifyContent: 'flex-end' }}>
            <button className="btn-cancel" onClick={() => setOpen(false)}>Cancel</button>
            <button className="btn-share" onClick={handleShare}><FaCheck /> Share</button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ShareModalPreview;
